'use strict';

var _objectSpread = require("/app/node_modules/@babel/runtime/helpers/objectSpread");

module.exports = function () {
  var rum = window.DD_RUM;
  var context = rum && rum.getInternalContext && rum.getInternalContext();
  return _objectSpread({}, context);
};